export default __webpack_public_path__ + "static/media/icon-octagon.1f8e8173.svg";